import { DataFilter } from '@siclop/kstone-vue'

export class WireframeFilter extends DataFilter {
  functionalityId?: number
  projectId?: number
  designSystemId?: number

  constructor(data?: Partial<WireframeFilter>) {
    super(data)
    if (data) {
      this.functionalityId = data.functionalityId
      this.projectId = data.projectId
      this.designSystemId = data.designSystemId
    }
  }
}
